module.exports = __webpack_public_path__ + "static/how-it-works-1-6f64ce00b167fad4134e827af2648816.svg";